// CSV parse + stringify — RFC 4180-ish (handles quoted fields, escaped quotes, newlines in quoted fields).

export function parseCSV(text) {
  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;
  let i = 0;
  const len = text.length;

  while (i < len) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i += 2;
          continue;
        }
        inQuotes = false;
        i += 1;
        continue;
      }
      field += ch;
      i += 1;
      continue;
    }
    if (ch === '"') {
      inQuotes = true;
      i += 1;
      continue;
    }
    if (ch === ",") {
      row.push(field);
      field = "";
      i += 1;
      continue;
    }
    if (ch === "\r") {
      i += 1;
      continue;
    }
    if (ch === "\n") {
      row.push(field);
      rows.push(row);
      row = [];
      field = "";
      i += 1;
      continue;
    }
    field += ch;
    i += 1;
  }
  // flush
  if (field.length || row.length) {
    row.push(field);
    rows.push(row);
  }

  if (rows.length === 0) return { headers: [], records: [] };
  const headers = rows[0].map((h) => h.trim());
  const records = rows.slice(1)
    .filter((r) => r.some((c) => c && c.trim()))
    .map((r) => {
      const obj = {};
      headers.forEach((h, idx) => {
        obj[h] = (r[idx] ?? "").trim();
      });
      return obj;
    });
  return { headers, records };
}

const needsQuote = (v) => /[",\r\n]/.test(v);
const escapeCell = (v) => {
  const s = v == null ? "" : String(v);
  return needsQuote(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function stringifyCSV(records, columns) {
  if (!records || records.length === 0) {
    if (!columns) return "";
    return columns.join(",") + "\n";
  }
  const cols = columns || Object.keys(records[0]);
  const lines = [cols.join(",")];
  for (const rec of records) {
    lines.push(cols.map((c) => escapeCell(rec[c])).join(","));
  }
  return lines.join("\n") + "\n";
}

export function downloadCSV(filename, csvText) {
  const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function readCSVFile(file) {
  const text = await file.text();
  return parseCSV(text);
}
